import React, { useState } from "react";
import AddCaregiver from "../../library/AddCaregiver/AddCaregiver";
import { addCaregiverReducer, mapDispatchToProps } from "./AddCaregiver.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { attachReducer } from "@redux-dynostore/redux-subspace";

export const SmartAddCaregiver = (props) => {
  const { addCaregiver, onClose, caregivers, participant } = props;

  const [error, setError] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");

  const onSubmit = (formData) => {
    setError(null);
    addCaregiver(formData)
      .then((obj) => {
        sendNotification(obj.message, ToastType.SUCCESS);
        onClose(obj);
      })
      .catch((errorMessage) => {
        setError(!!errorMessage);
        if (
          errorMessage &&
          errorMessage.startsWith("Participant already assigned")
        ) {
          setAlertMessage(errorMessage);
        } else {
          sendNotification(errorMessage, ToastType.ERROR);
        }
      });
  };

  return (
    <AddCaregiver
      {...{ onSubmit }}
      {...{ caregivers }}
      {...{ participant }}
      hasError={error}
      alertMessage={alertMessage}
      setAlertMessage={setAlertMessage}
    />
  );
};

export default dynamic(
  "AddCaregiverReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(addCaregiverReducer)
)(connect(null, mapDispatchToProps)(SmartAddCaregiver));
